package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Papua New Guinea Flag (20x15dp)
 *
 * - ISO Alpha-2: PG
 * - ISO Alpha-3: PNG
 * - ISO Numeric: 598
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.PapuaNewGuinea: ImageVector by lazy {
    ImageVector.Builder(
        name = "Papua New Guinea:PG:PNG:598:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE11C1B))) {
                moveTo(1.25f, 0f)
                lineTo(18.75f, 0f)
                arcTo(1.25f, 1.25f, 0f, isMoreThanHalf = false, isPositiveArc = true, 20f, 1.25f)
                lineTo(20f, 13.75f)
                arcTo(1.25f, 1.25f, 0f, isMoreThanHalf = false, isPositiveArc = true, 18.75f, 15f)
                lineTo(1.25f, 15f)
                arcTo(1.25f, 1.25f, 0f, isMoreThanHalf = false, isPositiveArc = true, 0f, 13.75f)
                lineTo(0f, 1.25f)
                arcTo(1.25f, 1.25f, 0f, isMoreThanHalf = false, isPositiveArc = true, 1.25f, 0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF1D1D1D)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                lineTo(20f, 15f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFEEEEF6)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.427f, 11.418f)
                horizontalLineTo(5.26f)
                lineTo(5.655f, 10.484f)
                lineTo(6.121f, 11.411f)
                lineTo(6.973f, 11.458f)
                lineTo(6.245f, 12.251f)
                lineTo(6.619f, 13.207f)
                lineTo(5.692f, 12.675f)
                lineTo(4.837f, 13.212f)
                lineTo(5.16f, 12.284f)
                lineTo(4.427f, 11.418f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFEEEEF6)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(1.927f, 8.918f)
                horizontalLineTo(2.76f)
                lineTo(3.155f, 7.984f)
                lineTo(3.621f, 8.911f)
                lineTo(4.473f, 8.958f)
                lineTo(3.745f, 9.751f)
                lineTo(4.119f, 10.707f)
                lineTo(3.192f, 10.175f)
                lineTo(2.337f, 10.712f)
                lineTo(2.66f, 9.784f)
                lineTo(1.927f, 8.918f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFEEEEF6)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.427f, 7.668f)
                horizontalLineTo(5.26f)
                lineTo(5.655f, 6.734f)
                lineTo(6.121f, 7.661f)
                lineTo(6.973f, 7.708f)
                lineTo(6.245f, 8.501f)
                lineTo(6.619f, 9.457f)
                lineTo(5.692f, 8.925f)
                lineTo(4.837f, 9.462f)
                lineTo(5.16f, 8.534f)
                lineTo(4.427f, 7.668f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFEEEEF6)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.07f, 10.353f)
                lineTo(6.642f, 10.334f)
                lineTo(6.848f, 9.743f)
                lineTo(7.08f, 10.33f)
                lineTo(7.607f, 10.381f)
                lineTo(7.133f, 10.716f)
                lineTo(7.515f, 11.31f)
                lineTo(6.851f, 11.062f)
                lineTo(6.277f, 11.318f)
                lineTo(6.58f, 10.733f)
                lineTo(6.07f, 10.353f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFEEEEF6)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.32f, 9.103f)
                lineTo(7.892f, 9.084f)
                lineTo(8.098f, 8.493f)
                lineTo(8.33f, 9.08f)
                lineTo(8.857f, 9.131f)
                lineTo(8.382f, 9.466f)
                lineTo(8.765f, 10.06f)
                lineTo(8.101f, 9.812f)
                lineTo(7.527f, 10.068f)
                lineTo(7.83f, 9.483f)
                lineTo(7.32f, 9.103f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFBCD17)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(13.177f, 1.25f)
                curveTo(13.177f, 1.25f, 11.247f, 1.635f, 11.789f, 4.319f)
                horizontalLineTo(11.513f)
                curveTo(11.513f, 4.319f, 11.536f, 4.179f, 11.271f, 4.097f)
                curveTo(11.006f, 4.014f, 11.059f, 4.045f, 10.923f, 4.097f)
                curveTo(10.786f, 4.148f, 9.955f, 4.097f, 9.955f, 4.097f)
                verticalLineTo(4.199f)
                lineTo(10.543f, 4.453f)
                curveTo(10.543f, 4.453f, 10.528f, 4.665f, 10.774f, 4.782f)
                curveTo(11.02f, 4.899f, 11.199f, 4.956f, 11.199f, 4.956f)
                curveTo(11.199f, 4.956f, 11.235f, 5.189f, 11.005f, 5.189f)
                curveTo(10.774f, 5.189f, 9.847f, 4.889f, 9.518f, 5.627f)
                curveTo(9.188f, 6.365f, 8.75f, 6.907f, 8.75f, 6.907f)
                horizontalLineTo(9.244f)
                lineTo(9.112f, 7.072f)
                horizontalLineTo(9.668f)
                lineTo(9.518f, 7.157f)
                curveTo(9.518f, 7.157f, 10.206f, 7.149f, 10.26f, 7.072f)
                curveTo(10.314f, 6.994f, 10.26f, 7.282f, 10.26f, 7.282f)
                curveTo(10.26f, 7.282f, 10.927f, 6.978f, 10.964f, 6.907f)
                lineTo(11.275f, 7.12f)
                lineTo(11.364f, 6.759f)
                lineTo(11.698f, 6.907f)
                lineTo(11.789f, 6.562f)
                curveTo(11.789f, 6.562f, 12.734f, 8.143f, 13.451f, 8.052f)
                verticalLineTo(7.79f)
                lineTo(14.105f, 8.052f)
                lineTo(14.188f, 7.936f)
                curveTo(14.188f, 7.936f, 14.978f, 8.258f, 15.221f, 8.288f)
                lineTo(15.048f, 7.936f)
                horizontalLineTo(15.221f)
                lineTo(15.048f, 7.282f)
                horizontalLineTo(15.221f)
                lineTo(14.874f, 6.759f)
                lineTo(14.971f, 6.617f)
                lineTo(14.907f, 6.431f)
                curveTo(14.907f, 6.431f, 16.179f, 6.836f, 16.122f, 7.481f)
                curveTo(16.064f, 8.126f, 15.498f, 8.386f, 15.498f, 8.386f)
                curveTo(15.498f, 8.386f, 14.955f, 8.552f, 14.464f, 8.517f)
                curveTo(14.464f, 8.517f, 14.853f, 8.977f, 15.678f, 8.821f)
                curveTo(16.502f, 8.665f, 16.775f, 7.866f, 16.775f, 7.866f)
                curveTo(16.775f, 7.866f, 17.153f, 8.651f, 16.842f, 9.064f)
                curveTo(16.531f, 9.476f, 15.145f, 9.766f, 15.145f, 9.766f)
                curveTo(15.145f, 9.766f, 15.647f, 10.06f, 16.122f, 9.985f)
                curveTo(16.597f, 9.909f, 17.336f, 9.496f, 17.479f, 8.821f)
                curveTo(17.623f, 8.146f, 16.985f, 6.901f, 16.696f, 6.759f)
                lineTo(16.582f, 6.327f)
                lineTo(16.842f, 6.431f)
                lineTo(16.309f, 5.128f)
                lineTo(16.567f, 5.185f)
                lineTo(15.814f, 4.247f)
                lineTo(16.021f, 4.183f)
                lineTo(14.98f, 3.435f)
                lineTo(15.292f, 3.352f)
                curveTo(15.292f, 3.352f, 14.522f, 2.962f, 13.644f, 3.435f)
                lineTo(13.652f, 3.272f)
                lineTo(13.421f, 3.311f)
                lineTo(13.435f, 3.131f)
                lineTo(13.664f, 2.784f)
                lineTo(13.32f, 2.651f)
                curveTo(13.32f, 2.651f, 13.598f, 2.233f, 13.557f, 2.239f)
                curveTo(13.557f, 2.239f, 13.247f, 2.328f, 13.264f, 2.29f)
                curveTo(13.264f, 2.29f, 13.42f, 1.887f, 13.379f, 1.898f)
                curveTo(13.379f, 1.898f, 13.02f, 2.021f, 13.073f, 1.959f)
                lineTo(13.211f, 1.713f)
                lineTo(13.177f, 1.25f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun PapuaNewGuineaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.PapuaNewGuinea,
            contentDescription = "Papua New Guinea Flag"
        )
    }
}
